module.exports = __webpack_public_path__ + "static/media/Mus.5a2896e2.PNG";